export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_grand-kasai-ngo/artifacts/qnjxwy6p_file_00000000885471f5a6ef25030bb63a7c.png";

export const LOGO_URL_LIGHT =
  "https://customer-assets.emergentagent.com/job_grand-kasai-ngo/artifacts/8qvnfe7z_e1568833297cae923622a67695559bf38ff08e0a4703a17d81cd4ab1faf90174.png";

export const IMAGES = {
  // GKNL official event photography
  heroHome:
    "https://customer-assets.emergentagent.com/job_grand-kasai-ngo/artifacts/o1jk5u1g_file_00000000640871fd9084445b81f04ba8.png",
  humanitarian:
    "https://customer-assets.emergentagent.com/job_grand-kasai-ngo/artifacts/o1jk5u1g_file_00000000640871fd9084445b81f04ba8.png",
  wedding:
    "https://customer-assets.emergentagent.com/job_grand-kasai-ngo/artifacts/oxxaf6ss_file_00000000a67c71f7b93e578e229bec3e.png",
  orphan:
    "https://customer-assets.emergentagent.com/job_grand-kasai-ngo/artifacts/ajfw9ty0_file_000000001a1871fdb8474321ff1ae78e.png",
  community:
    "https://customer-assets.emergentagent.com/job_grand-kasai-ngo/artifacts/aom9a66l_file_000000002bc071f7b476778dfa8e89b8.png",
  // Supporting stock imagery
  environment:
    "https://images.unsplash.com/photo-1763856957026-a74ab4f05891?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxwbGFudGluZyUyMHRyZWVzJTIwaGFuZHN8ZW58MHx8fHwxNzc2Mzc3MjQ5fDA&ixlib=rb-4.1.0&q=85",
  funeral:
    "https://images.unsplash.com/photo-1644696327800-397a5006dd0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxmdW5lcmFsJTIwc3VwcG9ydCUyMGdhdGhlcmluZ3xlbnwwfHx8fDE3NzYzNzcyNTR8MA&ixlib=rb-4.1.0&q=85",
};

export const CONTACT = {
  email: "grandkasainsangalubangu@gmail.com",
  phone1: "+1 (540) 214-0192",
  phone2: "+1 (803) 722-9655",
};

export const LEADERSHIP = {
  president: {
    name: "Jeff Chibangu wa Chibangu",
    phone: "+1 (803) 722-9655",
    roleKey: "president",
  },
  vp: {
    name: "Henry Frank Tutu",
    phone: "+1 (540) 214-0192",
    roleKey: "vpSecretary",
  },
  eventCoordinator: {
    name: "Boaz K.",
    phone: "",
    roleKey: "eventCoordinator",
  },
  advisors: [
    { name: "Gideon Milambo" },
    { name: "Minos Mwanda" },
    { name: "Sandra Kaja" },
    { name: "Francis Mabenga" },
  ],
  treasurers: [
    { name: "Therese Mukendi" },
    { name: "Mr. Kakoji" },
    { name: "Kapinga Mulenga" },
  ],
};

export const DONATION_PACKAGES = [
  { id: "supporter", amount: 25, labelKey: "supporter" },
  { id: "friend", amount: 50, labelKey: "friend" },
  { id: "advocate", amount: 100, labelKey: "advocate" },
  { id: "champion", amount: 250, labelKey: "champion" },
  { id: "patron", amount: 500, labelKey: "patron" },
];
